import { useParams, useSearchParams } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import PopupEntityAppContext from '../../../contextProviders/SplashScreenProviders/MiscProviders/PopupEntityAppProvider/PopupEntityAppContext';

const useEntityParams = () => {
  const popupEntityAppContext = useContext(PopupEntityAppContext);

  const { entityAppSlug, value, tabType, tabId } = useParams<{
    entityAppSlug: string;
    value: string;
    tabType?: string;
    tabId?: string;
  }>();

  const [searchParams] = useSearchParams();

  const params = useMemo((): {
    entityAppSlug: string;
    value: string;
    tabType?: string;
    tabId?: string;
  } => {
    if (!!popupEntityAppContext) {
      return {
        entityAppSlug: popupEntityAppContext.poppedUpApp.app.urlSlug,
        value: popupEntityAppContext.poppedUpApp.entityValue,
        tabType: searchParams.get('tabType') || undefined,
        tabId: searchParams.get('tabId') || undefined,
      };
    }

    return {
      entityAppSlug: decodeURIComponent(entityAppSlug || ''),
      value: decodeURIComponent(value || ''),
      tabType,
      tabId,
    };
  }, [
    entityAppSlug,
    popupEntityAppContext,
    searchParams,
    tabId,
    tabType,
    value,
  ]);

  return params;
};

export default useEntityParams;
